import { createIcon } from '@chakra-ui/react/icon'

const CloseIconFilled = createIcon({
  displayName: 'CloseIconFilled',
  viewBox: '0 0 16.666 16.667',
  path: (
    <path
      d="M8.33301 0C12.9354 1.12739e-07 16.666 3.73161 16.666 8.33398C16.6659 12.9363 12.9353 16.667 8.33301 16.667C3.7307 16.667 0.00011006 12.9363 0 8.33398C0 3.73161 3.73063 0 8.33301 0ZM11.4219 5.24316C11.0965 4.91822 10.5695 4.91824 10.2441 5.24316L8.33301 7.1543L6.42188 5.24414C6.09641 4.91874 5.56857 4.91867 5.24316 5.24414C4.91782 5.56961 4.91772 6.09747 5.24316 6.42285L7.1543 8.33301L5.24414 10.2441C4.91881 10.5696 4.9187 11.0975 5.24414 11.4229C5.56955 11.7481 6.09746 11.7481 6.42285 11.4229L8.33301 9.51172L10.2441 11.4219C10.5696 11.7471 11.0965 11.7471 11.4219 11.4219C11.7473 11.0964 11.7473 10.5686 11.4219 10.2432L9.51172 8.33301L11.4219 6.42188C11.7473 6.09641 11.7473 5.56857 11.4219 5.24316Z"
      fill="white"
    />
  ),
})

export default CloseIconFilled
